<template>
  <div class="cart-item-container">
    <p class="item-title">{{itemTitle}} <span class="warning">Shipping details needed</span></p>
    <div class="item-details-container">
      <div v-if="isBox" class="item-box">
        <img class="box-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/emptybox_1.png?v=1659452617">
        <div class="addon-images">
            <img class="addon-image" v-for="image in boxImages" :key="image" :src="image"/>
        </div>
      </div>
      <img v-else class="item-box" :src="boxImages"/>
      <div class="item-details">
        <div v-if="isBox" class="details-container">
          <p><strong>Content:</strong> {{itemData.Items}}</p>
          <p><strong>Box:</strong> {{itemData.Box}}</p>
          <p><strong>Card:</strong> {{itemData.Card}}</p>
          <p><strong>Shipping:</strong> Email Shipping</p>
        </div>
        <div :class="!this.canAddMore ? 'no-more' : ''" class="quantity-container">
          <button :disabled="currentQty < minQty + 1" @click="updateCartItemQuantity(false)">-</button>
          <p>{{currentQty}}</p>
          <button v-if="isMobile"
            @click="updateCartItemQuantity(true)"
            v-tooltip="{content: 'Not enough inventory',container: false }"
          >
          +
          </button>
          <button v-else
            @click="updateCartItemQuantity(true)"
            @mouseenter="setButtonHover(true)" 
            @mouseleave="setButtonHover(false)"  
            v-tooltip="{content: 'Not enough inventory', show: shouldHover, trigger: ['manual'] }"
          >
          +
          </button>
        </div>
      </div>
    </div>
    <div>
      <button @click="openForm">Open Modal</button>
      <div v-if="currentFormData.recipients" class="recipients-container">
        <p class="recipient-title">Recipients</p>
        <div class="shipped-table">
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th v-if="currentFormData.recipients.length > 1">Notification Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="recipient in currentFormData.recipients" :key="recipient.email">
                        <td>{{recipient.firstName}} {{ recipient.lastName }}</td>
                        <td>{{recipient.email}}</td>
                        <td v-if="currentFormData.recipients.length > 1">{{recipient.notificationDate.toLocaleString("en-US",{}).split("T")[0]}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as XLSX from "xlsx"
import Swal from 'sweetalert2/dist/sweetalert2.js'
export default {
    components:{
  },
  props:{
    cartItem: Object,
    position: Number,
    formData: Object
  },
  data(){
    return{
      isHovering: false,
      currentFormData: {},
    };
  },
  watch: {
    formData:{
      handler(formSubmitData){
        if(formSubmitData.product == this.cartItem){
          this.currentFormData = formSubmitData;
        }
      }
    }
  },
  computed:{
    ...mapGetters([
      'currentCart',
      'addonProducts',
    ]),
    itemTitle(){
        return `${this.position + 1}. ${this.boxName}`
    },
    boxName(){
      if(this.cartItem.properties._gs_bundle_ids){
        return this.cartItem.properties.boxName
      }
      else {
        return this.cartItem.title
      }
    },
    itemData(){
      return this.cartItem.properties;
    },
    boxImages(){
      if(this.isBox)
        return this.cartItem.properties.productImages
      else 
        return this.cartItem.image
    },
    currentQty(){
      if(this.cartItem)
        return this.cartItem.quantity;
      return 0;
    },
    currentExtraItemsQty(){
      if(this.isBox){
        var extraCart = [];
        var itemIds = this.cartItem.properties._gs_bundle_ids.slice(0, -3);
        var itemQuantities = this.cartItem.properties._gs_bundle_quantities;
        for (let id of itemIds){
          let index = itemIds.indexOf(id);
          extraCart.push({variantId: id,quantity:itemQuantities[index] * (this.currentQty + 1)});
        }

        return extraCart
      }

      return [];
    },
    ItemsQty(){
      if(this.isBox){
        var extraCart = [];
        var itemIds = this.cartItem.properties._gs_bundle_ids.slice(0, -3);
        var itemQuantities = this.cartItem.properties._gs_bundle_quantities;
        for (let id of itemIds){
          let index = itemIds.indexOf(id);
          extraCart.push({variantId: id,quantity:itemQuantities[index]});
        }

        return extraCart
      }

      return [];
    },
    productsVariants(){
      var products = [];
      if(this.isBox){
        var itemIds = this.cartItem.properties._gs_bundle_ids.slice(0, -3)
        var products = this.addonProducts.filter(x => x.variants.some(y => itemIds.includes(y.id))).flatMap(x => x.variants.filter(y => itemIds.includes(y.id)));
      }

      return products;
    },
    canAddMore(){
      //check other cart items products
      if(this.isBox){
        let otherCarts = this.currentCart.items.filter(x => x != this.cartItem && x.product_type == "GIST_BUILDER_PRODUCT").flatMap((x) => {
          var cartIds = x.properties._gs_bundle_ids.slice(0, -3);
          var objects = [];
          for (let id of cartIds){
            let index = x.properties._gs_bundle_ids.indexOf(id);
            objects.push({variantId: id,quantity:x.properties._gs_bundle_quantities[index] * x.quantity});
          }
          return objects
        })

        otherCarts = otherCarts.concat(this.currentExtraItemsQty)

        let result = Object.values(otherCarts.reduce((c, {variantId,quantity}) => {
          c[variantId] = c[variantId] || {variantId,quantity: 0};
          c[variantId].quantity += quantity;
          return c;
        }, {}));

        
        return this.productsVariants.every(x => x.inventory_quantity >= result.find(y => y.variantId == x.id).quantity)
      }
      else{
        let product = this.addonProducts.find(x => x.variants.some(y => y.id == this.cartItem.variant_id));
        if(!product)
          return true;
        let currentVariant = product.find(x => x.id == this.cartItem.variant_id);

        return currentVariant >= (this.cartItem.quantity + 1);
      }
    },
    maximumQty(){
      if(this.isBox){
        let otherCarts = this.currentCart.items.filter(x => x != this.cartItem && x.product_type == "GIST_BUILDER_PRODUCT").flatMap((x) => {
          var cartIds = x.properties._gs_bundle_ids.slice(0, -3);
          var objects = [];
          for (let id of cartIds){
            let index = x.properties._gs_bundle_ids.indexOf(id);
            objects.push({variantId: id,quantity:x.properties._gs_bundle_quantities[index] * x.quantity});
          }
          return objects
        })

        let result = Object.values(otherCarts.reduce((c, {variantId,quantity}) => {
          c[variantId] = c[variantId] || {variantId,quantity: 0};
          c[variantId].quantity += quantity;
          return c;
        }, {}));

        let maximumQtys = this.productsVariants.map((x) => {
          let maxQty = x.inventory_quantity;
          let otherCartItem = result.find(y => y.variantId == x.id);
          if(otherCartItem){
            maxQty = maxQty - otherCartItem.quantity;
          }
          let currentItem = this.ItemsQty.find(y => y.variantId == x.id);
          return Math.floor(maxQty / currentItem.quantity);
        })

        return Math.min(...maximumQtys);

      }else{
        let product = this.addonProducts.find(x => x.variants.some(y => y.id == this.cartItem.variant_id));
        if(!product)
          return 999;
        let currentVariant = product.find(x => x.id == this.cartItem.variant_id);
        return currentVariant.inventory_quantity;
      }
    },
    shouldHover(){
      if(this.canAddMore == false && this.isHovering == true){
        return true;
      }
      return false;
    },
    isBox(){
      return this.cartItem.properties._gs_bundle_ids ? true : false
    },
    isMobile(){
      return window.innerWidth < 768;
    },
    minQty(){
      let qtyMinTag = this.cartItem.properties.qtyMin;
      if(qtyMinTag){
        return parseInt(qtyMinTag);
      }

      return 1
    }
  },
  methods:{
    updateCartItemQuantity(increment){
      this.isHovering = true;
      if(increment){
        if(this.canAddMore)
          this.$store.commit('updateCartItem',{cartItem: this.cartItem, quantity: (this.currentQty + 1)});
      }
      else{
        if(this.currentQty > this.minQty){
          this.$store.commit('updateCartItem', {cartItem: this.cartItem,quantity: (this.currentQty - 1)});
        }
      }
    },
    openForm(){
      this.$emit("openform",this.cartItem);
    },
    setButtonHover(state){
      this.isHovering = state;
    },
  },
}
</script>

<style scoped>
  .cart-item-container{
    width: 100%;
    border: 1px solid #ebeef0;
    padding: 2%;
  }

  .boxes-container .cart-item-container:not(:first-child){
    margin-top: 3%;
  }

  .item-title{
    color: #0F0C38;
    font-weight: 700;
    font-size: 1.4vw;
    line-height: 1.6;
  }

  .item-title .warning{
    font-weight: 400;
    font-size: 1vw;
    line-height: 1.4;
    color: #E11D48;
    background: #FFE4E6;
    border-radius: 4px;
    padding: 4px 8px;
    margin-left: 2%;
  }

  .item-details p{
    font-size: 1vw;
    line-height: 1.4;
    color: #0F0C38;
    margin: unset;
  }

  .item-details-container{
    width: 100%;
    display: flex;
  }

  .item-details{
    width: 50%;
    padding-left: 2%;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
  }

  .directions-container{
    width: 100%;
    padding: 2%;
  }

  .directions-container p{
    margin: unset;
    color: #0f0c38;
}

  .directions-title{
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    padding-bottom: 2%;
  }

  .directions-subtitle{
    font-size: 1vw;
    line-height: 1.4;
    padding-bottom: 2%;
  }

  .directions-subtitle a{
    text-decoration: underline;
    color: blue;
  }

  .file-uploader{
    height: unset !important;
    border: unset !important;
    margin: unset;
    padding: 1% 0% !important;
    font-size: 1.2vw;
    color: #0f0c38;
  }

  .addresses-container{
    width: 100%;
    background-color: #F9FAFB;
    padding: 2%;
  }

  .addresses-container p{
    margin: unset;
    color: #0F0C38;
  }

  .addresses-title{
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    padding-bottom: 2%;
  }

  .addresses-subtitle{
    font-weight: 700;
    font-size: 1vw;
    line-height: 1.4;
    padding-bottom: 2%;
  }

  .multiple-addresses-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .title-container{
    display: flex;
    width: 100%;
    align-items: center;
    margin-top: 2%;
  }

  .title-container p{
    font-weight: bold;
    font-size: 1.4vw;
    line-height: 1.6;
  }

  .title-container p:first-child{
    width: 25%;
  }

  .addresses-qty-selector{
    width: 20%;
  }

  .address-container{
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 2%;
    justify-content: space-between;
  }

  .address-qty-selector{
    width: 20%;
  }

  .address-selector{
    width: 70%;
  }

  .addresses-qty-selector,.address-qty-selector,.address-selector{
    border: 1px solid #E5E7EB;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 4px;
    height: unset;
    font-size: 1vw;
  }

  .address-container button{
    font-weight: bold;
    font-size: 14px;
    color: #0f0c38;
    cursor: pointer;
  }
  

  .add-address{
    font-weight: bold;
    font-size: 1vw;
    line-height: 150%;
    color: #0f0c38;
    cursor: pointer;
    margin-top: 2%;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .add-address.disabled{
    opacity: 0.6;
  }

.quantity-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 7px;
}

.quantity-container button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 8px;
  width: 36px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  box-shadow: 0 1px 2px #1f293714;
  border-radius: 4px;
  font-size: 1.5vw;
  color: #000;
}

.quantity-container button:disabled{
  background-color: #F3F4F6;;
}

.quantity-container button:hover,.quantity-container button:active{
  background-color: #faf7fe;;
}

.quantity-container p{
  font-size: 1vw;
  line-height: 1.43;
  text-align: center;
  padding: 0% 5%;
  color: #0f0c38;
}

  .item-box{
    width: 30%;
    position: relative;
    display: flex;
  }

  .item-box .box-image{
    width: 100%;
  }

  .item-box .addon-images{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    padding: 10%;
    overflow: hidden;
  }

  .item-box .addon-images .addon-image{
    width: 25%;
    max-width: 50%;
    flex: 0 1 auto;
  }

  .addon-image:first-child:nth-last-child(1) {
    width: auto;
    max-width: 100%;
    max-height: 100%;
  }

  .addon-image:first-child:nth-last-child(2),
  .addon-image:first-child:nth-last-child(2) ~ .addon-image {
    width: auto;
    max-width: 50%;
    max-height: 100%
  }

  .addon-image:first-child:nth-last-child(3),
  .addon-image:first-child:nth-last-child(3) ~ .addon-image {
    width: auto;
    height: 50%;
  }

  .addon-image:first-child:nth-last-child(4),
  .addon-image:first-child:nth-last-child(4) ~ .addon-image {
    width: auto;
    height: 50%;
  }

  .addon-image:first-child:nth-last-child(5),
  .addon-image:first-child:nth-last-child(5) ~ .addon-image {
    width: auto;
    max-width: 33%;
    max-height: 50%;
  }

  .addon-image:first-child:nth-last-child(6),
  .addon-image:first-child:nth-last-child(6) ~ .addon-image {
    width: auto;
    max-width: 33%;
    max-height: 50%;
  }

  .recipient-title{
    font-size: 1.5vw;
    line-height: 1;
    color: #0f0c38;
    margin-top: 5%;
    margin-bottom: 2%;
    font-weight: bold;
  }

  .recipients-container{
    width: 100%;
  }

  .shipped-table{
      width: 100%;
      overflow-x: scroll;
  }
  .shipped-table th{
      font-size: 1vw;
      border: unset;
      color: #0f0c38;
      padding: unset;
      text-align: center;
  }
  .shipped-table tbody{
      background-color: #fafbff;
      font-size: 1vw;
  }

  .shipped-table td{
      padding: 5px;
      text-align: center;
  }

  .shipped-table tbody,.shipped-table tbody th,.shipped-table tbody td {
      border: 1px solid #b5b6b8;
      border-collapse: collapse;
  }

  @media screen and (max-width: 767px) {

    .item-details-container{
      flex-direction: column;
    }

    .item-box,.item-details{
      width: 100%;
    }

    .item-details,.quantity-container{
      padding-top: 5%;
    }

    .item-details p,.quantity-container p,.addresses-subtitle,.add-address,.addresses-qty-selector, .address-qty-selector, .address-selector,.item-title .warning,.directions-subtitle{
      font-size: 3.5vw;
    }

    .addresses-title,.title-container p,.directions-title,.file-uploader{
      font-size: 4vw;
    }

    .item-title{
      font-size: 4.2vw;
    }

    .quantity-container button{
      font-size: 4.5vw;
    }

    .quantity-container button .tooltip{
      display: none;
    }

    .quantity-container .no-more .tooltip{
      display: inherit;
    }

    .addresses-container,.directions-container{
      padding: 4%;
      margin-top: 5%;
    }
  }
</style>